import SubscriptionsTabLayout from "./SubscriptionsTabLayout";
import CommonTable from "../CommonTable/CommonTable";
import Select from "react-select";
import makeAnimated from 'react-select/animated';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import useSubscriptionPeriods from "./useSubscriptionPeriods";
import {useEffect, useMemo, useState} from "react";
import invoiceService from "../../services/invoice.service";
import moment from "moment";
const MonitoringSubscriptionsTab = ({id , onFilterChange})=> {
    const animatedComponents = makeAnimated();
    const monitoringOnlyId = 3;
    const freeEntryStatusId = 3;
    let total = {
        active: 0,
        earlyTermination: 0
    };
    const showingOptions = [
        {
            value: 'Active',
            label: 'Active'
        },
        {
            value: 'Early Terminations',
            label: 'Early Terminations'
        },
        {
            value: 'Both',
            label: 'Both'
        }
    ];
    const periods = useSubscriptionPeriods();
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [showing, setShowing ] = useState(showingOptions[0]);
    const [summary, setSummary ] = useState(total);
    const [mappedData, setMappedData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (periods.length === 0) return;
        setSelectedPeriod(prev => prev ?? periods[0]);
    }, [periods]);

    useEffect(() => {
        if (!selectedPeriod) return;
        //filter by period
        let dateRange = selectedPeriod.value.split('-');
        let star = dateRange[0].trim();
        let end = dateRange[1].trim();
        const fetchDataAsync = async () => {
            setLoading(true);
            try {
                let response = await invoiceService.full(id, star, end);
                let invoiceDate = end;//response.invoiceDate;
                let customers = response.customers;
                let mappedData = customers.flatMap(customer=>(customer.billingSubscriptions || []).map(sub=>({
                    deviceId:sub.deviceId,
                    name: customer.customerName,
                    address: customer.address,
                    start: moment(sub.start).calendar(),
                    planId: sub.planId,
                    end: sub.terminationDate === null ? null: moment(sub.terminationDate).calendar(),
                    isLpx: sub.isLpx,
                    quitLengthClassificationId: sub.quitLengthClassificationId
                })));
                setMappedData(mappedData);
            }finally {
                setLoading(false);
            }
        };

        fetchDataAsync().catch(error => {});

    }, [id, selectedPeriod]);
    
    const getActiveByPeriod = (filtered, invoicePeriodEndDate) =>{
        //filter by subscription length
        return  filtered.filter(o=>(o.end === null || new Date(o.end)  > invoicePeriodEndDate) && o.planId === monitoringOnlyId);
    }
    const earlyTerminationSubscriptionsByPeriod = (filtered, invoicePeriodEndDate) => {
       return  filtered.filter(o=>o.planId === monitoringOnlyId && o.quitLengthClassificationId !== null && new Date(o.end) <= invoicePeriodEndDate);
    }
    const getSummary = (data, invoicePeriodEndDate) => {
        if (data.length) {
            total.active = getActiveByPeriod(data, invoicePeriodEndDate).length;
            total.earlyTermination = earlyTerminationSubscriptionsByPeriod(data, invoicePeriodEndDate).length;
            setSummary(total);
        }
    }
    const data = useMemo(() => {
        if(!selectedPeriod) return;
        //filter by period
        let dateRange = selectedPeriod.value.split('-');
        let starDate = dateRange[0].trim();
        let endDate = new Date(dateRange[1].trim());
        let filtered = [...mappedData];
        getSummary(filtered, endDate);
        //filtering active or terminated
        if (showing.value === "Active") {
            filtered = getActiveByPeriod(filtered, endDate);
        }else if(showing.value === "Early Terminations"){
            filtered = earlyTerminationSubscriptionsByPeriod(filtered, endDate);
        }else{
            let active = getActiveByPeriod(filtered, endDate);
            let canceled = earlyTerminationSubscriptionsByPeriod(filtered, endDate);
            filtered = active.concat(canceled);
        }
        onFilterChange(filtered);
        return filtered;
    }, [mappedData, showing]);
    
    let filters =
        <div className="alerts-tab-wrapper alerts-tab-top-wrapper">
            <div className="row no-gutters pad-left-40 margin-5">
                <div className="alerts-tab-options">
                    &nbsp; Billing Date: &nbsp;&nbsp;
                    <span className="min-width-200 margin-right-20">
                            <Select
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                options={periods}
                                onChange={setSelectedPeriod}
                                defaultValue={selectedPeriod}
                                value={selectedPeriod}
                            />
                        </span>
                    &nbsp; Showing: &nbsp;&nbsp;
                    <span className="min-width-200 margin-right-20">
                            <Select
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                options={showingOptions}
                                onChange={setShowing}
                                defaultValue={showingOptions[0]}
                                value={showing}
                            />
                        </span>
                </div>
            </div>
        </div>;

    let summaryComponent =
        <div className="alerts-tab-wrapper alerts-top-tabs">

            <div className="row no-gutters margin-top-15">
                <div className="col-2">
                    <Card elevation={0}>
                        <CardContent className="pad-unset">
                            <h6 className="text-center">Active</h6>
                            <div className="row no-gutters card-row  text-center font-size-80p margin-top-12 margin-bottom-15">

                                <div className="col-4 offset-4 dashboard-val" onClick={() => setShowing(showingOptions[0])}>
                                    <div className="dashboard-number margin-bottom-4">
                                        {summary.active}
                                    </div>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </div>

                <div className="col-3 offset-1 justify-content-left">
                    <Card elevation={0}>
                        <CardContent className="pad-unset">
                            <h6 className="text-center">Terminations</h6>
                            <div className="row no-gutters card-row  text-center font-size-80p margin-top-12 margin-bottom-15">

                                <div className="col-4 offset-4 dashboard-val"  onClick={() => setShowing(showingOptions[1])}>
                                    <div className="dashboard-number margin-bottom-4">
                                        { summary.earlyTermination}
                                    </div>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </div>;
    
    const columns = [
        {field: 'deviceId', header: 'DEVICE ID'},
        {field: 'name', header: 'NAME'},
        {field: 'address', header: 'ADDRESS'},
        {field: 'start', header: 'CONTRACT START DATE'}
    ];
    
    return (
        <SubscriptionsTabLayout
            filters={filters}
            summary={summaryComponent}
            table={
                <div className="margin-20-30">
                    <div className="justify-content-center">
                        <CommonTable columns={columns} data={data ?? []} loading={loading} />
                    </div>
                </div>}
        />
    );
}
export default MonitoringSubscriptionsTab;